import { cn } from '@ais-ui/utils';
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';
import { PiInfo } from 'react-icons/pi';

interface InfoTooltipProps {
  className?: string;
  children?: React.ReactNode;
}

const InfoTooltip = React.forwardRef<HTMLDivElement, InfoTooltipProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'z-50 overflow-hidden absolute left-10 h-8 w-full bottom-0 min-w-min border bg-popover whitespace-nowrap px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 rounded-md',
          className,
        )}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

InfoTooltip.displayName = 'InfoTooltip';

const InfoIconTooltip = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger tabIndex={-1} onClick={(event) => event.preventDefault()}>
        <PiInfo className={cn('text-primary', className)} />
      </TooltipTrigger>
      <TooltipContent className="max-w-[400px] whitespace-normal break-words">
        {children}
      </TooltipContent>
    </Tooltip>
  );
};

export { InfoTooltip, InfoIconTooltip };
